// src/pages/EventCalendar.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import WeeklyActivityFront from './WeeklyActivityFront';

export default function EventCalendar() {
  const navigate = useNavigate();

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <WeeklyActivityFront />

      <button
        onClick={() => navigate('/')}
        style={{
          position: 'fixed',
          bottom: 12,
          left: '50%',
          transform: 'translateX(-50%)',
          padding: '8px 24px',
          fontSize: 14,
          fontWeight: 800,
          border: '1.5px solid #5e3a1a',
          borderRadius: 10,
          background: 'rgba(240,223,212,.96)',
          color: '#5e3a1a',
          cursor: 'pointer',
          zIndex: 9000,
          boxShadow: '0 2px 10px rgba(94,58,26,.18)',
          letterSpacing: 2,
          lineHeight: 1.4,
        }}
      >
        返回會員卡
      </button>
    </div>
  );
}
